import React from 'react'
import Button from 'react-bootstrap/Button';
const PrimaryOutLineButton = ({outlinebuttonText, className , onClick, disabled=false}) => {
  return (
    <>
        <Button disabled={disabled} className={`outlineBtn  ${className}`} onClick={onClick}><span><p className='grTxt'>{outlinebuttonText}</p></span></Button>
    </>
  )
}
export default PrimaryOutLineButton

